import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ProductCardCoreSkeletonComponent } from '../../../../catalog/product-card-core';

@Component({
  selector: 'ui-shopping-list-item-skeleton',
  imports: [
    ProductCardCoreSkeletonComponent,
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './shopping-list-item-skeleton.component.html',
  styleUrls: ['./shopping-list-item-skeleton.component.scss', '../shopping-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShoppingListItemSkeletonComponent {
  public displayListView: InputSignal<boolean> = input(false);
}
